import React from "react";

const ActivityLogComponent = ({ activities, title }) => {
  // console.log({ activities });
  return (
    <div className="row">
      <div className="col-md-6">
        <p>{title}</p>
        {activities && activities.length > 0 ? (
          activities.map((activity, index) => (
            <div className="card" key={index}>
              <div className="card-body p-1">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg">
                    <div className="avatar-content font-medium-3">
                      {activity.name
                        ? activity.name[0].toUpperCase() +
                          activity.name[1].toUpperCase()
                        : "G"}
                    </div>
                  </div>
                  <div className="px-2">
                    <div className="fw-bolder">
                      {activity.name} <span>@ {activity.username}</span>
                    </div>
                    <div
                      className="font-small-3 activity-message"
                      style={{ padding: "5px 0" }}
                    >
                      {activity.message}
                    </div>
                    <div className="font-small-3 activity-message">
                      {activity.days_ago}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No Activity</p>
        )}
      </div>
    </div>
  );
};

export default ActivityLogComponent;
